export default function ScoreRing({ value = 0, size = 180, label = "Overall" }) {
    const v = Math.max(0, Math.min(100, value));
    const radius = (size - 16) / 2;
    const circumference = 2 * Math.PI * radius;
    const dash = (v / 100) * circumference;
    const color = v >= 80 ? "#7B8B6F" : v >= 60 ? "#E06D53" : v >= 40 ? "#D88B3F" : "#C45A4D";

    return (
        <div className="relative inline-flex items-center justify-center" data-testid="score-ring">
            <svg width={size} height={size} className="-rotate-90">
                <circle cx={size / 2} cy={size / 2} r={radius} stroke="hsl(var(--border))" strokeWidth="8" fill="none" />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={color}
                    strokeWidth="10"
                    strokeLinecap="round"
                    fill="none"
                    strokeDasharray={`${dash} ${circumference}`}
                    style={{ transition: "stroke-dasharray 800ms cubic-bezier(0.16,1,0.3,1)" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <div className="font-serif text-5xl sm:text-6xl font-light tracking-tight" style={{ color }} data-testid="score-ring-value">
                    {v}
                </div>
                <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-stone-400 mt-1">{label}</div>
            </div>
        </div>
    );
}
